"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * A querySelectorAll that returns a normal array rather than live node list.
 *
 * @param  {String} selector
 * @param  {HTMLElement} context
 * @return {Array}
 */
var queryAll = function queryAll(selector, context) {
  context = context || document;
  return Array.prototype.slice.call(context.querySelectorAll(selector));
};

var _default = queryAll;
exports["default"] = _default;